// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import {downloadFile} from '../../../shared/services/file-download';

/* eslint-disable react/prefer-stateless-function */

function onFileClick(file) {

    downloadFile(file);

}

class FileCellRenderer extends Component {

    render() {

        return (
            <div className='claim-cell-renderer'>
                {this.props.value.fileName &&
                    <button
                        className='button-text'
                        onClick={onFileClick.bind(null, this.props.value)}
                    >
                        {this.props.value.fileName}
                    </button>}
            </div>
        );

    }

}

FileCellRenderer.displayName = 'FileCellRenderer';
FileCellRenderer.propTypes = {
    value: PropTypes.string.isRequired
};

export default FileCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/file-cell-renderer.js